import { jsx as _jsx } from "react/jsx-runtime";
import { Tags } from 'lucide-react';
import { createModulePerms } from '@wit-support/ui-domain';
import { ClassificationListPage } from './routes/list-page.js';
const { Provider: ClassificationModulePermsProvider, usePerms: useClassificationPerms } = createModulePerms({ canManage: false });
export { ClassificationModulePermsProvider };
function ClassificationPageRoute() {
    const { canManage } = useClassificationPerms();
    return _jsx(ClassificationListPage, { canManage: canManage });
}
export const classificationModule = {
    id: 'classification',
    label: 'Классификация',
    icon: Tags,
    permission: 'topics.list',
    workspace: 'support',
    order: 50,
    description: 'Taxonomy of classification topics.',
    routes: [{ path: '/', component: ClassificationPageRoute }],
};
export { ClassificationListPage } from './routes/list-page.js';
export { setClassificationApiBaseUrl } from './api.js';
//# sourceMappingURL=index.js.map